import classnames from "classnames";
import PropTypes from "prop-types";
import Benefit from "./benefit-component";
import { withGenericConfig } from "/contexts/generic-config-context";
import { componentStyles } from "./template-benefits.scss";

const TemplateBenefits = ({ benefits, alignToCenter, translate }) => {
  if (!benefits || benefits.length === 0) return null;

  return (
    <div className={classnames("template-benefits", { "align-center": alignToCenter })}>
      <div className="template-benefits-main-title">{translate("templateCenter.benefits.title")}</div>
      {benefits.map((benefit, index) => (
        <div className="template-benefit-wrapper">
          <Benefit key={`benefit_${index}`} {...benefit} alignToCenter={alignToCenter} />
        </div>
      ))}
      <style jsx>{componentStyles}</style>
    </div>
  );
};

TemplateBenefits.propTypes = {
  alignToCenter: PropTypes.bool,
  benefits: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      description: PropTypes.string
    })
  )
};

TemplateBenefits.defaultProps = {
  alignToCenter: false,
  benefits: []
};

export default withGenericConfig(TemplateBenefits);
